import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';

var PegRedemptionCard = function PegRedemptionCard(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      selectedValues = props.selectedValues,
      setSelectedValues = props.setSelectedValues,
      available = props.available;
  var PegNumber = model.PegNumber,
      Copy = model.Copy;

  var handleClick = function handleClick(pegs) {
    if (!available) return;
    setSelectedValues(function (prev) {
      if ((prev === null || prev === void 0 ? void 0 : prev.pegs) === pegs) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          pegs: null
        });
      } else {
        return _objectSpread(_objectSpread({}, prev), {}, {
          pegs: pegs
        });
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "peg-redemption-card ".concat(!available ? 'peg-redemption-card--unavailable' : '', " ").concat(parseInt((PegNumber === null || PegNumber === void 0 ? void 0 : PegNumber.value) || "0") === parseInt((selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.pegs) || 0) ? 'peg-redemption-card--selected' : '', " "),
    onClick: function onClick() {
      return handleClick(parseInt((PegNumber === null || PegNumber === void 0 ? void 0 : PegNumber.value) || "0"));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'peg-redemption-card__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'peg-redemption-card__peg-number'
  }, PegNumber === null || PegNumber === void 0 ? void 0 : PegNumber.value), /*#__PURE__*/React.createElement("div", {
    className: 'peg-redemption-card__copy'
  }, Copy === null || Copy === void 0 ? void 0 : Copy.value))));
};

export default PegRedemptionCard;